<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
    <div id="pagebody" class="container">
      <Goals id="goals"></Goals>
    </div>
  </div>
</template>

<script>

import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from '@/components/Navbar'
import Goals from '@/components/Goals'


export default {
  name: 'goalspage',
  components: {
    HelloWorld,
    Navbar,
    Goals
  },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<style>

#navbar {
  margin-bottom: 80px;
}

</style>
